module.exports = __webpack_public_path__ + "fonts/fa-brands-400.d9d17590.eot";